import React from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';

import { capitalizeTopic } from 'src/app/shared/utils/topic';

import { TextMessage } from './components/TextMessage';
import { VideoMessage } from './components/VideoMessage';
import { useSupporterVoices } from './hooks/useSupporterVoices';

export const SupporterVoices: React.FC = () => {
	const {
		data: { shouldShowSupporterVoices, supporterVoices, topicName, totalSupporterVoices },
	} = useSupporterVoices();

	// If there are less than 3 supporter voices, we don't show the section
	// In addition, we check if signees should be hidden via hideSignees FCM value
	if (!shouldShowSupporterVoices) return null;

	return (
		<div className="flex flex-col gap-10">
			<Text as="h2" variant="heading" className="text-typography-strong" data-qa="supporter-voices-heading">
				<Translate
					value="corgi.topic_page.supporter_voices.title.headline"
					replacements={{ count: totalSupporterVoices, topic: capitalizeTopic(topicName) }}
				/>
			</Text>

			<div className="b-1 scroll-ps-[10vw] scroll-pe-[10vw] overflow-x-auto md:pb-3">
				<div className="flex gap-6 pl-1">
					{supporterVoices.map((voice) => {
						if (voice.type === 'text') {
							return <TextMessage supporterVoice={voice} key={voice.id} />;
						}

						return <VideoMessage supporterVoice={voice} key={voice.id} />;
					})}
				</div>
			</div>
		</div>
	);
};
